import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import AsyncSelect from "react-select/lib/Async";
import LoadMask from "Utils/LoadMask/LoadMask";
import { Controller, useForm } from "react-hook-form";
import { CreacionPTApi } from "../api/CreacionPTApi";
import { useDebouncedAsyncSelect } from "../../../../../Utils/Hooks/useDebounce";
import {
    NumberField,
    SwitchField,
} from "../../../../../Utils/renderField/fieldsHookForms";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { NotificationManager } from "react-notifications";
import { SOLIDO } from "../../../../../../../utility/constants";

export const FormPT = ({ idProductoTerminado, regresar }) => {
    const {
        getTiposProducto,
        getPadresProductoTerminado,

        crearPT,
        actualizarPT,
        getDetalleMateriaPrima,
        cargando,
    } = CreacionPTApi();

    const {
        control: formControl,
        register: formRegister,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        watch: formWatch,
        formState: { errors },
    } = useForm({
        mode: "onChange",
    });

    const loadTiposProducto = useDebouncedAsyncSelect(function (search) {
        return getTiposProducto({ search: search });
    });

    const loadPadresProductoTerminado = useDebouncedAsyncSelect(
        function (search) {
            return getPadresProductoTerminado({ search: search });
        },
    );

    const tipoProductoSeleccionado = formWatch("tipo_materia_prima");
    const esProductoSolido = tipoProductoSeleccionado
        ? tipoProductoSeleccionado.tipo === SOLIDO
        : false;

    const FormSubmit = async () => {
        const isValid = await validateForm();
        if (!isValid) return;

        const formValues = formGetValues();

        const padreProductoFinal =
            esProductoSolido && formValues.padre_producto_terminado
                ? formValues.padre_producto_terminado.id
                : null;

        const body = {
            es_materia_prima: false,
            es_producto_final: true,
            es_subproducto: false,

            nombre: formValues.nombre,
            tipo_materia_prima: formValues.tipo_materia_prima.id,
            cve_sae: formValues.cve_sae,
            cve_sae_trading: formValues.cve_sae_trading,

            es_contable: formValues.es_contable,
            padre_producto_terminado: padreProductoFinal,
            creando: !idProductoTerminado,
        };

        if (idProductoTerminado) {
            EditarPT(body);
        } else {
            CrearPT(body);
        }
    };

    const EditarPT = async (body) => {
        try {
            await actualizarPT(idProductoTerminado, body);
            NotificationManager.success(
                "Producto terminado actualizado correctamente",
                "Éxito",
                3000,
            );
            regresar();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al actualizar producto terminado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const CrearPT = async (body) => {
        try {
            await crearPT(body);

            NotificationManager.success(
                "Producto terminado creado correctamente",
                "Éxito",
                3000,
            );

            regresar();
        } catch (error) {
            const errorMsg = getErrorFromResponse(error, "Error al crear producto terminado");
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const GetDetalleMateriaPrima = async () => {
        try {
            const data = await getDetalleMateriaPrima(idProductoTerminado);
            formSetValue("nombre", data.nombre);
            formSetValue("tipo_materia_prima", data.tipo_materia_prima);
            formSetValue("cve_sae", data.cve_sae);
            formSetValue("cve_sae_trading", data.cve_sae_trading);
            formSetValue("es_contable", data.es_contable);
            formSetValue("padre_producto_terminado", data.padre_producto_terminado);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al cargar detalle de producto terminado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        if (idProductoTerminado) {
            GetDetalleMateriaPrima();
        }
    }, [idProductoTerminado]);

    return (
        <LoadMask loading={cargando} blur>
            <div
                className="d-flex justify-content-between flex-wrap align-items-end mb-3 mx-auto"
                style={{ maxWidth: "750px" }}
            >
                <h4 className="mb-0">Datos de Producto Terminado</h4>
                <div className="formulario-fields-row w-100 gap-1rem flex-wrap mb-0">
                    <div className="formulario-field">
                        <label className="text-nowrap">PRODUCTO FINAL</label>
                        <input
                            type="text"
                            {...formRegister("nombre", {
                                required: "Este campo es obligatorio",
                            })}
                            className="form-control"
                        />
                        {errors.nombre && (
                            <small className="text-danger">
                                {errors.nombre.message}
                            </small>
                        )}
                    </div>

                    <div className="formulario-field">
                        <label className="text-nowrap">TIPO DE PRODUCTO</label>
                        <Controller
                            name="tipo_materia_prima"
                            control={formControl}
                            rules={{
                                required:
                                    "Debe seleccionar un tipo de producto",
                            }}
                            render={({ field }) => (
                                <AsyncSelect
                                    {...field}
                                    className="react-select-container"
                                    isSearchable
                                    isClearable
                                    defaultOptions
                                    loadOptions={loadTiposProducto}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.nombre}
                                    onChange={(selected) => {
                                        field.onChange(selected);
                                    }}
                                />
                            )}
                        />
                        {errors.tipo_materia_prima && (
                            <small className="text-danger">
                                {errors.tipo_materia_prima.message}
                            </small>
                        )}
                    </div>
                </div>

                <div className="formulario-fields-row w-100 gap-1rem flex-wrap mb-0">
                    <div className="formulario-field">
                        <label className="text-nowrap">CLAVE SAE</label>
                        <input
                            type="text"
                            {...formRegister("cve_sae", {
                                required: "Este campo es obligatorio",
                            })}
                            className="form-control"
                        />
                        {errors.cve_sae && (
                            <small className="text-danger">
                                {errors.cve_sae.message}
                            </small>
                        )}
                    </div>

                    <div className="formulario-field">
                        <label className="text-nowrap">CLAVE SAE TRADING</label>
                        <input
                            type="text"
                            {...formRegister("cve_sae_trading", {
                                required: "Este campo es obligatorio",
                            })}
                            className="form-control"
                        />
                        {errors.cve_sae_trading && (
                            <small className="text-danger">
                                {errors.cve_sae_trading.message}
                            </small>
                        )}
                    </div>
                </div>

                <div className="formulario-fields-row w-100 gap-1rem flex-wrap mb-0">
                    {esProductoSolido && (
                        <div className="formulario-field">
                            <label className="text-nowrap">
                                PADRE DE PRODUCTO TERMINADO
                            </label>
                            <Controller
                                name="padre_producto_terminado"
                                control={formControl}
                                rules={{
                                    required:
                                        "Debe seleccionar un padre de producto terminado",
                                }}
                                render={({ field }) => (
                                    <AsyncSelect
                                        {...field}
                                        className="react-select-container"
                                        isSearchable
                                        isClearable
                                        defaultOptions
                                        loadOptions={
                                            loadPadresProductoTerminado
                                        }
                                        getOptionValue={(option) => option.id}
                                        getOptionLabel={(option) =>
                                            option.nombre
                                        }
                                        onChange={(selected) => {
                                            field.onChange(selected);
                                        }}
                                    />
                                )}
                            />
                            {errors.padre_producto_terminado && (
                                <small className="text-danger">
                                    {errors.padre_producto_terminado.message}
                                </small>
                            )}
                        </div>
                    )}

                    <div
                        className={`formulario-field horizontal gap-1rem pt-1 ${esProductoSolido ? "mt-4 justify-content-center" : ""}`}
                    >
                        <label className="text-nowrap">CONTABILIZAR</label>
                        <SwitchField
                            name="es_contable"
                            control={formControl}
                            label=""
                        />
                    </div>
                </div>

                <div className="d-flex justify-content-center gap-1rem flex-wrap mt-5 w-100">
                    <button
                        type="button"
                        className="btn btn-outline-dark"
                        onClick={regresar}
                    >
                        Regresar
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={FormSubmit}
                    >
                        Guardar
                    </button>
                </div>
            </div>
        </LoadMask>
    );
};
